import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './styles/index.css';

const App = lazy(() => import('./App'));

const theme = createTheme({
  palette: {
    primary: {
      main: '#156683',
    },
    secondary: {
      main: '#4D616C',
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </ThemeProvider>
  </React.StrictMode>
);
